import { render, staticRenderFns } from "./QRCodeScanner.vue?vue&type=template&id=172451fa&scoped=true"
import script from "./QRCodeScanner.vue?vue&type=script&lang=js"
export * from "./QRCodeScanner.vue?vue&type=script&lang=js"
import style0 from "./QRCodeScanner.vue?vue&type=style&index=0&id=172451fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172451fa",
  null
  
)

export default component.exports